import React, { Component } from 'react';
import autobind from 'react-autobind';
import isBackOffice from 'utils/appUtils';
import PropTypes from 'prop-types';
import { Steps, Icon, Button } from 'antd';
import translate from 'app/translations';

import { stepsPropType } from '../AgentProfilePropType';

const { Step } = Steps;

export default class Stepper extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  formatTitle(stepType, isBo, isCurrent) {
    return isBo
      ? (
        <Button
          onClick={() => { this.props.onSetAgentProfileStepRequest(stepType); }}
          className="btn-link"
          type="button"
          disabled={isCurrent}
          style={{ backgroundColor: '#fff' }}
        >
          <span
            className={isCurrent ? 'emphasized-text bold' : 'pointer'}
          >
            {this.t(`AgentProfileSteps.${stepType}`)}
          </span>
        </Button>
      )
      : this.t(`AgentProfileSteps.${stepType}`);
  }

  render() {
    const {
      direction,
      currentPage,
      steps,
    } = this.props;

    const isBo = isBackOffice;

    return (
      <Steps
        direction={direction}
        size="small"
        current={steps.findIndex(s => s.type === currentPage)}
        className="step-wrap"
      >
        {steps.map(step => (
          <Step
            key={step.type}
            status={isBo ? 'finish' : undefined}
            title={this.formatTitle(step.type, isBo, step.type === currentPage)}
            icon={(
              <Icon
                title={this.t(`AgentProfileSteps.${step.type}`)}
                className="step-icon"
                type={step.icon}
              />
            )}
          />
        ))}
      </Steps>
    );
  }
}

Stepper.propTypes = {
  direction: PropTypes.string.isRequired,
  currentPage: PropTypes.string.isRequired,
  steps: PropTypes.arrayOf(stepsPropType).isRequired,
  onSetAgentProfileStepRequest: PropTypes.func.isRequired,
};
